module.exports = __webpack_public_path__ + "pin_brown.8f4929.png";